import 'css-chunk:src/app/containers/Projects/ProjectsPage/WorkItemsList/ShopifyReauthenticateModal.scss';export default {
  "ShopifyReauthenticateModal": "_ShopifyReauthenticateModal_fsyx0_1",
  "errorIcon": "_errorIcon_fsyx0_7",
  "actionButton": "_actionButton_fsyx0_10"
};